// cameraModule/index.js
export { useCameraPhoto } from './hooks/useCameraPhoto';
export { useVideoRecorder } from './hooks/useCameraVideo';
export { useGalleryPhoto } from './hooks/useGalleryPhoto';
export { useImageProcessing } from './hooks/useImageProcessing';